import {FETCH_USERS, DELETE_USER, MODIFY_USER, ADD_USER} from './actions';
import {LOGOUT} from './../user/actions';

import restCollection from './../_utils/restReducer';

export default restCollection({
  defaultStateAugment: {},
  actions: {
    index: {
      start: FETCH_USERS.do,
      success: FETCH_USERS.success,
      failure: FETCH_USERS.failure
    },
    delete: {
      start: DELETE_USER.do,
      success: DELETE_USER.success,
      failure: DELETE_USER.failure
    },
    put: {
      start: MODIFY_USER.do,
      success: MODIFY_USER.success,
      failure: MODIFY_USER.failure
    },
    post: {
      start: ADD_USER.do,
      success: ADD_USER.success,
      failure: ADD_USER.failure
    },
    reset: [LOGOUT]
  },
  fallback: (state/*, action*/) => {
    return state;
  }
});



// WEBPACK FOOTER //
// ./src/redux/users/reducer.js